import React from 'react'
import PropTypes from 'prop-types'
import Button from '@components/Button'

const CMSButton = ({ link, ...props }) => {
  const pageSlug = link.page?.slug
  const caseStudySlug =
    link.page?.internal.type === 'ContentfulPartnerPage'
      ? `what-we-do/${link.page.parentService.slug}/${pageSlug}`
      : false
  // const articleSlug =
  //   link.page?.internal.type === 'ContentfulArticle'
  //     ? `insights/${pageSlug}`
  //     : false
  // const serviceSlug =
  //   link.page?.internal.type === 'ContentfulService'
  //     ? `what-we-do/${pageSlug}`
  //     : false

  return (
    <>
      {link.page && (
        <Button
          type="internalLink"
          to={caseStudySlug ? caseStudySlug : pageSlug ? pageSlug : ''}
          {...props}
        >
          {link.text}
        </Button>
      )}

      {link.url && (
        <Button type="externalLink" href={link.url} {...props}>
          {link.text}
        </Button>
      )}
    </>
  )
}

CMSButton.propTypes = {
  link: PropTypes.object,
}

export default CMSButton
